import { connect } from "react-redux";

import * as actions from "./action";
//TODO this should really be done with services approach
function mapStateToProps(state) {
  return {
    referAFriend: state.referAFriend,
  };
}

function mapDispatchToProps(dispatch) {
  return {
    addCampaign: (addCampaignDto) => {
      dispatch(actions.add_campaign(addCampaignDto));
    },
    getCampaigns: () => {
      dispatch(actions.get_campaigns());
    },
    getReferred: () => {
      dispatch(actions.get_referred());
    },
    deleteCampaign: (name) => {
      dispatch(actions.delete_campaign(name));
    },
    registerAllBonusOrders: (list) => {
      dispatch(actions.register_all_bonus_orders(list));
    },
    updateStartDate: (stringTime, id) => {
      dispatch(actions.update_start_date(stringTime, id));
    },
    updateEndDate: (stringTime, id) => {
      dispatch(actions.update_end_date(stringTime, id));
    },
  };
}

const refAFriendConnector = connect(mapStateToProps, mapDispatchToProps);
export default refAFriendConnector;
